import { api } from "./base";

export const getAbout = async ({ locale }) => {
  api.defaults.headers = { locale };
  const res = await api.get("/about-us");
  return res.data;
};
